import { useMemo } from "react";

import { GetResidentsFilterStatus } from "@graphql/api";

export const useGetResidentsFilters = () => {
  return useMemo(
    () => [
      {
        label: GetResidentsFilterStatus.All,
        value: GetResidentsFilterStatus.All,
      },
      {
        label: "Requirement Satisfied",
        value: GetResidentsFilterStatus.RequirementSatisfied,
        tooltip:
          "The community's blanket renters liability (BRL) policy is active and on file — resident is fully covered.",
      },
      {
        label: "Pre Review",
        value: GetResidentsFilterStatus.PreReview,
        tooltip:
          "The resident hasn't yet signed the addendum, or their effective date hasn't been reached.",
      },
      {
        label: "Under Review",
        value: GetResidentsFilterStatus.UnderReview,
        tooltip:
          "The resident submitted their personal insurance policy and it is currently under review.",
      },
      {
        label: "BRL-Scheduled",
        value: GetResidentsFilterStatus.RequirementUnsatisfied,
        tooltip:
          "A blanket renters liability policy has been issued and is pending its coverage effective date.",
      },
      {
        label: GetResidentsFilterStatus.Excluded,
        value: GetResidentsFilterStatus.Excluded,
        tooltip: "This resident is exempt from the insurance requirement.",
      },
    ],
    []
  );
};
